import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../static/index/image-top/index-bg.png';
import _imports_1 from '../../static/index/content-1/7.png';
import _imports_2 from '../../static/common/close.png';
import _imports_3 from '../../static/common/mp-code.png';

const _withScopeId = n => (_pushScopeId("data-v-7f0df49a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "index-box header-top"
};
const _hoisted_2 = {
  class: "index-box-content"
};
const _hoisted_3 = {
  class: "content-top-image"
};

const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<img class=\"image\" src=\"" + _imports_0 + "\" alt=\"\" data-v-7f0df49a><div class=\"title-box\" data-v-7f0df49a><div class=\"title wow slideInRight\" data-v-7f0df49a>迪想校园</div><div class=\"des wow slideInLeft\" data-v-7f0df49a>外卖+跑腿+校园信息全方位校园服务平台</div><div class=\"line wow slideInLeft\" data-v-7f0df49a></div></div>", 2);

const _hoisted_6 = {
  class: "block-box"
};
const _hoisted_7 = ["data-wow-delay", ":key"];
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
  class: "item-right"
};
const _hoisted_10 = {
  class: "title"
};
const _hoisted_11 = {
  class: "content-1-box"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title wow fadeInDown"
}, "产品介绍", -1));

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "detail wow fadeInDown"
}, "搭建平台整合校园周边资源，为师生提供综合性服务", -1));

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des wow bounceInRight"
}, "迪想校园是一个面向高校市场的校园共享经济生活服务平台。学生可以通过平台叫外卖、找人代取快递、发布跑腿办事需 求、发布技能服务需求等等，平台限制最低服务费，用户也可以额外增加赏金，只要你能想到的校园内的生活需求统统可 以在迪想校园平台上发布。 ", -1));

const _hoisted_15 = {
  class: "fun"
};
const _hoisted_16 = {
  class: "fun-left"
};
const _hoisted_17 = ["data-wow-delay"];
const _hoisted_18 = ["src", "alt"];
const _hoisted_19 = {
  class: "fun-left_item__name"
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fun-right wow flipInY"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "fun-right_image",
  src: _imports_1
})], -1));

const _hoisted_21 = {
  class: "content-2-box"
};

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title wow bounceInLeft"
}, "满足你校园里各种碎片化需求", -1));

const _hoisted_23 = {
  class: "content-2-box_content"
};

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title wow bounceInLeft"
}, "三大运营场景", -1));

const _hoisted_25 = {
  class: "content-2-box_content__scene"
};
const _hoisted_26 = ["data-wow-delay"];
const _hoisted_27 = ["src", "alt"];

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-yellow"
}, null, -1));

const _hoisted_29 = {
  class: "name"
};

const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-black"
}, null, -1));

const _hoisted_31 = {
  class: "des"
};
const _hoisted_32 = {
  class: "content-3-box"
};

const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title wow fadeInUp"
}, "深挖校园市场，提供多种运营方式", -1));

const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des wow fadeInUp"
}, "在对的时间找对的人", -1));

const _hoisted_35 = {
  class: "content"
};
const _hoisted_36 = ["data-wow-delay"];
const _hoisted_37 = {
  class: "item-title"
};
const _hoisted_38 = {
  class: "item-bottom"
};
const _hoisted_39 = ["src", "alt"];
const _hoisted_40 = {
  class: "des"
};
const _hoisted_41 = {
  class: "content-4-box"
};

const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title wow rotateInDownLeft"
}, "深挖校园市场，提供多种运营方式", -1));

const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "detail wow rotateInDownLeft"
}, "5年运营开发经验", -1));

const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des wow rotateInDownLeft"
}, "5年数十所高校运营经验，提供全程精细化解决方案", -1));

const _hoisted_45 = {
  class: "content"
};
const _hoisted_46 = ["data-wow-delay"];
const _hoisted_47 = ["src", "alt"];
const _hoisted_48 = {
  class: "item-title"
};
const _hoisted_49 = {
  class: "item-des"
};
const _hoisted_50 = {
  class: "header"
};

const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "image",
  src: _imports_3,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, " 扫码关注公众号了解更多 ")], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Header = _resolveComponent("Header");

  const _component_Follow = _resolveComponent("Follow");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Header, {
    activeIndex: 0,
    onClickHeader1: _ctx.header1,
    onClickHeader2: _ctx.header2,
    siteInfo: $data.siteInfo
  }, null, 8, ["onClickHeader1", "onClickHeader2", "siteInfo"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.blockList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "block-box_item wow slideInUp",
      "data-wow-delay": index * 0.1 + 's',
      ":key": index,
      onClick: _cache[0] || (_cache[0] = (...args) => $options.showDialog && $options.showDialog(...args))
    }, [_createElementVNode("img", {
      class: "item-left",
      src: item.image,
      alt: item.title
    }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(item.title), 1), _createElementVNode("div", null, _toDisplayString(item.describe), 1)])], 8, _hoisted_7);
  }), 256))])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _hoisted_13, _hoisted_14, _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.funLeftList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "fun-left_item wow fadeInUp",
      "data-wow-delay": index * 0.05 + 's',
      key: index
    }, [_createElementVNode("img", {
      class: "fun-left_item__image",
      src: item.image,
      alt: item.name
    }, null, 8, _hoisted_18), _createElementVNode("div", _hoisted_19, _toDisplayString(item.name), 1)], 8, _hoisted_17);
  }), 128))]), _hoisted_20])]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.sceneList, (scene, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "scene-item wow zoomInDown",
      "data-wow-delay": index * 0.1 + 's',
      key: index
    }, [_createElementVNode("img", {
      class: "image",
      src: scene.image,
      alt: scene.name
    }, null, 8, _hoisted_27), _hoisted_28, _createElementVNode("div", _hoisted_29, _toDisplayString(scene.name), 1), _hoisted_30, _createElementVNode("div", _hoisted_31, _toDisplayString(scene.des), 1)], 8, _hoisted_26);
  }), 128))])])]), _createElementVNode("div", _hoisted_32, [_hoisted_33, _hoisted_34, _createElementVNode("div", _hoisted_35, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.schoolBazaarList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "content-item wow fadeInUp",
      "data-wow-delay": index * 0.05 + 's',
      key: index
    }, [_createElementVNode("div", _hoisted_37, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_38, [_createElementVNode("img", {
      class: "image",
      src: item.image,
      alt: item.name
    }, null, 8, _hoisted_39), _createElementVNode("div", _hoisted_40, _toDisplayString(item.des), 1)])], 8, _hoisted_36);
  }), 128))])]), _createElementVNode("div", _hoisted_41, [_hoisted_42, _hoisted_43, _hoisted_44, _createElementVNode("div", _hoisted_45, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.selectDXList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "content-item wow rotateInDownLeft",
      "data-wow-delay": index * 0.05 + 's',
      key: index
    }, [_createElementVNode("img", {
      class: "image",
      src: item.image,
      alt: item.name
    }, null, 8, _hoisted_47), _createElementVNode("div", _hoisted_48, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_49, _toDisplayString(item.des), 1)], 8, _hoisted_46);
  }), 128))])])]), _createVNode(_component_Follow), _createVNode(_component_Footer, {
    siteInfo: $data.siteInfo
  }, null, 8, ["siteInfo"]), $data.dialogVisible ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "diy-dialog-box",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.hideDialog && $options.hideDialog(...args))
  }, [_createElementVNode("div", {
    class: "diy-dialog-box-centent wow zoomIn",
    "data-wow-duration": "0.3s",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [_createElementVNode("div", _hoisted_50, [_createElementVNode("img", {
    class: "close-image",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.hideDialog && $options.hideDialog(...args)),
    src: _imports_2,
    alt: ""
  })]), _hoisted_51])])) : _createCommentVNode("", true)]);
}